<template>
  <div id="logged-out-page" data-component="layout-logged-out" class="full-height-container">
    <div id="login-image" :class="webpSupport ?'side-image side-image-webp':'side-image'" />
    <b-row class="m-0 full-height" align-h="end">
      <b-col cols="12" md="6" lg="5" xl="4" class="p-0 full-height" id="logged-out-content">
        <slot/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import User from "@/app/models/user";

export default {
  name: "LayoutLoggedOut",
  data() {
    return {
      user: new User("", ""),
      loading: false,
      err: [],
    };
  },

  mounted() {
    if (this.webpSupport) {
      import(
        /* webpackMode: "eager", webpackChunkName: "app-login-webp" */ "@/assets/images/login/LoginPage.webp"
      );
    } else {
      import(
        /* webpackMode: "eager", webpackChunkName: "app-login-jpg" */ "@/assets/images/login/LoginPage.jpg"
      );
    }

    this.$store.dispatch("hideGlobalLoadingOverlay", "entering application");
    if (this.loggedIn) this.safeRouterPush("/project-selection");
  },

  computed: {
    loggedIn() {
      return this.$store.getters["auth/loggedIn"];
    },
    message() {
      var errorObject = this.$store.getters["auth/loginError"];
      if (!errorObject) return null;
      if (errorObject.key == "Invalid name or password.")
        return this.$t("login.login-fail.$");
      else if (errorObject.key) return this.$t(errorObject.key);
      else if (errorObject.localizedMessage)
        return errorObject.localizedMessage;
      return "unknown error";
    },
    webpSupport() {
      return this.$store.getters["webpLossySupport"];
    },
    sm() {
      return this.$store.getters["sm"];
    },
  },

  methods: {
    handleLogin() {
      this.loading = true;

      // validate
      this.err = [];
      if (this.user.username == "") this.err.push("username");
      if (this.user.password == "") this.err.push("password");

      if (this.err.length != 0) {
        this.loading = false;
        return;
      }

      if (this.user.username && this.user.password) {
        this.$store.dispatch("auth/login", { user: this.user }).then(
          () => {
            this.safeRouterPush("/project-selection");
          },
          // error handler
          () => {
            this.loading = false;
          }
        );
      }
    },
    forgetPassword() {
      this.safeRouterPush("/password-recovery");
    },
  }, // methods
};
</script>

<style scoped>
#logged-out-content >>> label {
  display: block;
  margin-top: 10px;
}

#logged-out-content >>> .card {
  width: 95%;
  max-width: 20rem !important;
  margin: 0 auto;
  border: 0px;
  background-color: transparent;
}

#logged-out-content >>> .profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
}

#logged-out-content >>> .spinner-border {
  margin-right: 10px;
}

#logged-out-content >>> .floating-form {
  position: fixed;
  right: 100px;
}
/* ------------------------------------------------------------------ */

.template-left {
  display: flex;
  flex-direction: row;
  min-height: 100%;
}

.template-left_content {
  text-align: left;
  padding: 0;
  background: #fff;
  overflow: auto;
  box-sizing: border-box;
  min-height: 100%;
}
.template-left_content-right {
  position: relative;
  flex: 65vw 1;
}
.template-left_content-left {
  flex: 35vw 1;
  justify-content: space-between;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.template-left_content-right .login-image-cont {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  height: 100%;
  width: 65vw;
}

/* ---------------------------------------------------- */

.template-right {
  display: flex;
  flex-direction: row;
  min-height: 100%;
  width: 100vw;
}

.template-right_content {
  text-align: left;
  padding: 0;
  background: #fff;
  overflow: auto;
  box-sizing: border-box;
  min-height: 100%;
}
.template-right_content-left {
  position: relative;
  flex: 65vw 1;
}

.template-right_content-right {
  flex: 35vw 1;
  justify-content: space-between;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.template-right_content-left .login-image-cont {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  height: 100%;
  /* width: 65vw; */
}

/* ---------------------------------------------------- */

.col-12, .col-md-6, .col-xl-4, .col-lg-5 {
  transition: all 0.5s ease-out;
}

.side-image {
  position: fixed;
  width: 66.6667%;
  height: 100%;
  left: 0;
  opacity: 0;
  background-repeat: no-repeat;
  background-position: center right;
  background-size: cover;
  background-image: url("../assets/images/login/LoginPage.jpg");
}

.side-image-webp {
  background-image: url("../assets/images/login/LoginPage.webp");
}

@media (min-width: 1200px) {
  .side-image {
    width: 66.6667%;
  }
}

@media (max-width: 1199px) {
  .side-image {
    width: 58.3333%;
    opacity: 0 !important;
    transition: all 0.5s ease-out;
  }
}

@media (max-width: 992px) {
  .side-image {
    width: 50%;
    opacity: 0 !important;
    transition: all 0.5s ease-out;
  }
}

@media (max-width: 768px) {
  .side-image {
    width: 0% !important;
    opacity: 0 !important;
    transition: all 0.5s ease-out;
  }
}

@media (min-width: 767px) {
  .side-image {
    opacity: 1 !important;
    transition: all 0.5s ease-out;
  }
}

.login-image-cont .login-image-background {
  width: 100%;
  height: 100%;
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}

.full-height {
  height: 100% !important;
}

img.banner {
  height: 30px;
}

.top {
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
</style>